import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=1bfa4f20&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=1bfa4f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa4f20",
  null
  
)

export default component.exports